// @flow
import * as React from 'react';
import cx from 'classnames';

import cs from './field.pcss';
import t from './locale';

export type Props = {
  onChange: (val: string) => void,
  id: string,
  value: string | null,
  error: boolean,
  element: any,
  maxLength?: number,
  disabled?: boolean,
};

export default function Field({
  error,
  id,
  onChange,
  value,
  element,
  maxLength,
  disabled,
  ...rest
}: Props): React.Node {
  const Component = element;

  return (
    <label htmlFor={id} className={cs.wrapper}>
      <div className={cs.label}>{t(`field.${id}.label`)}</div>
      <div className={cs.inputWrapper}>
        {/* $FlowFixMe */}
        <Component
          id={id}
          name={id}
          value={value}
          placeholder={t(`field.${id}.placeholder`)}
          className={cx(cs.input, {
            [cs.inputError]: error,
            [cs.textarea]: element === 'textarea',
            [cs.select]: element !== 'input' && element !== 'textarea',
          })}
          onChange={(changeArg) => {
            let val =
              element === 'input' || element === 'textarea'
                ? changeArg.target.value
                : changeArg;

            if (
              element === 'textarea' &&
              maxLength &&
              changeArg.target.value.length > maxLength
            ) {
              val = val.slice(0, maxLength);
            }

            onChange(val);
          }}
          disabled={disabled}
          {...rest}
        />
        {error && <div className={cs.error}>{t(`field.${id}.error`)}</div>}
      </div>
    </label>
  );
}
